import { useContext } from "react";
import { AnimalMeasurementContext } from "../../contexts/animalMeasurementContext";

export default function useAnimalMeasurementContext() {
  const value = useContext(AnimalMeasurementContext);
  return value;
}
